<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >
    <block-hero :target-info="targetInfo" :color-scheme="colorScheme"/>
    <block-fortune-input
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :action="action"
      :method="method"
      :token="token"
      :lp-id="lpId"
      pageLabel="basicinput"
      :event-label="1"
      btn-label="<span>▶︎</span>無料で占う"
    >
      <div class="label">オッティモちゃんの<br>宇宙占術ＲＰＵを無料で体験</div>
    </block-fortune-input>
    <block-about-counselor :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <block-about-fortune :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/>
    <block-review :target-info="targetInfo" :color-scheme="colorScheme" :review-list="reviewListMod" :lp-id="lpId"/>
    <template v-if="!hideAddvertise">
      <block-menus
        v-if="menusList && menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :lp-id="lpId"
        :subscr-enable="+salesInvalid > 0"
        :no-swipe="true"
      />
      <!-- <block-menus v-if="menusList && menusList.length" :target-info="targetInfo" :color-scheme="colorScheme" :menu-list="menusList" :lp-id="lpId"/> -->
      <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
      <!--
      <block-banner
        class="block-banner--middle"
        v-if="showBanner"
        banner-pos="1"
        :lp-id="lpId"
        :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="true"
      />
      -->
      <!--
      <block-uranai-tv
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :is-individualed="false"
      />
      -->
    </template>
    <!--
    <block-banner
      v-if="showBanner"
      :lp-id="lpId"
      banner-pos="bottom"
      :color-scheme="colorScheme"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :campaign="bannerType" :target-info="targetInfo"
    />
    -->
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockUranaiTv from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTv'
import BlockHero from './blocks/BlockHero'
import BlockReview from './blocks/BlockReview' //個別階層にコピー
import BlockAboutCounselor from './blocks/BlockAboutCounselor2'
import BlockAboutFortune from './blocks/BlockAboutFortune2'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockFortuneInput from './blocks/BlockFortuneInput'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockHero,
    BlockAboutCounselor,
    BlockAboutFortune,
    BlockReview,
    BlockMenus,
    BlockUranaiTv,
    BlockBanner,
    LineCampaignMessage,
    BlockFortuneInput,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    campaignMessage: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
    token: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post',
    }
  },
  computed:{
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  font-family: "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic Pro", "source-han-sans-japanese", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #32373F;
  &--validCpno {
  }
  &--invalidCpno {
    .block-review-base {
      //padding-bottom: 0;
    }
  }
  .block-menu-base {
    padding-bottom: 22px;
  }
  .block-uranaitv-base {
    padding-top: 36px;
  }
  .block-banner--middle {
    //background: #F3FEFF;
    //padding: 8px 0 60px;

    background: white;
    padding: 40px 0 60px;
  }

  /deep/ {
    .block-about-counselor-base {
      h2 {
        display: none;
      }
      &__img {
        display: none;
      }
    }
    .block-review-base {
      h2 {
        span {
          text-align: left;
          text-indent: -9999px;
          overflow: hidden;
          display: inherit;
          width: 100%;
          background: url(/static/img/recommend/lp/ottimo/header_reviews.png) no-repeat center center;
          background-size: auto 100%;
          height: 1em;
        }
      }
    }

  }
  .block-fortune-input {
    background: #fff;
    padding: 40px 37px 60px;
    .label {
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: $l_col_keycolor;
      margin: 0 -10px 30px;
    }
    /deep/ {
      .content-wrap {
        padding: 0;
        max-width: 400px;
        margin: auto;
      }
      .form-label { display: none;}
      .formGroup .calenderForm.formControl {
        width: 100% !important;
        background: #fff;
        justify-content: center;
        // max-width: 300px;
        margin: auto;
        overflow: hidden;
        height: 48px !important;
        > * {
          flex: 0 1 0;
          font-size: 16px;
          line-height: 26px;
          outline: none;
          margin: 0;
        }
        .date_unit {
          right: 0px;
        }
      }
      .submit-btn {
        margin-top: 30px !important;
        width: auto !important;
      }
      .baseButton__button {
        // filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.25));
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        min-width: auto;
        &__label {
          font-size: 22px;
          span {
            margin-right: 16px;
          }
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/LpMain.vue